(function(){
if (window._oryQuizLoaded) return;
window._oryQuizLoaded = true;
/* ══════════════════════════════════════════════════════════════
   CONFIG
   variantId: Shopify Admin → Produkte → URL endet auf /variants/XXXXXXX
   handle:    z.B. 'neurotransmitter-basis' aus /products/neurotransmitter-basis
══════════════════════════════════════════════════════════════ */
const SHOP         = 'https://www.ory-berlin.de';
const COACHING_URL = 'https://ory-berlin.de/pages/fuer-patienten';

/* Konkrete Produkte je Analysebereich – Stufen: klein / mittel / groß
   Felder: probe = Probenart, params = bis 5 Hauptparameter, desc_de/en = Kurzbeschreibung */
const PRODUCTS = {
  stress: [
    { de:'Neurotransmitter Basis', en:'Neurotransmitter Basic', price:'€ 97,70', variantId:54971714601346, handle:'neurotransmitter-basis',
      probe:'Urin', params:'Adrenalin · Noradrenalin · Dopamin · Serotonin · GABA',
      desc_de:'Misst zentrale Stressbotenstoffe und Neurotransmitter im Urin.',
      desc_en:'Measures key stress messengers and neurotransmitters in urine.' },
    { de:'Cortisol-Tagesprofil', en:'Cortisol Day Profile', price:'€ 138,50', variantId:54971412709762, handle:'cortisol-tagesprofil',
      probe:'Speichel (4×)', params:'Cortisol morgens · mittags · abends · nachts',
      desc_de:'Zeigt den Cortisolanstieg und -abfall über den Tag in 4 Messungen.',
      desc_en:'Shows cortisol rise and fall across the day in 4 measurements.' },
  ],
  neuro: [
    { de:'Neurotransmitter Basis', en:'Neurotransmitter Basic', price:'€ 97,70', variantId:54971714601346, handle:'neurotransmitter-basis',
      probe:'Urin', params:'Adrenalin · Noradrenalin · Dopamin · Serotonin · GABA',
      desc_de:'Misst zentrale Stressbotenstoffe und Neurotransmitter im Urin.',
      desc_en:'Measures key stress messengers and neurotransmitters in urine.' },
    { de:'Neurotransmitter Plus', en:'Neurotransmitter Plus', price:'€ 185,90', variantId:54971711553922, handle:'neurotransmitter-plus',
      probe:'Urin', params:'Adrenalin · Dopamin · Serotonin · Glutamat · GABA · Histamin · Noradrenalin',
      desc_de:'Erweitertes Neurotransmitter-Profil inkl. Abbauprodukte und Vorläufer.',
      desc_en:'Extended neurotransmitter profile incl. metabolites and precursors.' },
    { de:'Neurotransmitter Tryptophan Metabolismus Plus', en:'Neurotransmitter Tryptophan Metabol. Plus', price:'€ 340,70', variantId:55578484310402, handle:'tryptophan-metabolismus-test-plus',
      probe:'Urin', params:'Serotonin · Tryptophan · Kynurenin · 5-HIAA · Melatonin',
      desc_de:'Umfassendstes Neurotransmitter-Profil inkl. vollständigem Tryptophan-Stoffwechselweg.',
      desc_en:'Most comprehensive neurotransmitter profile incl. full tryptophan pathway.' },
  ],
  darm: [
    { de:'Histamin Stuhltest', en:'Histamine Stool Test', price:'€ 49,50', variantId:54971640578434, handle:'histamin',
      probe:'Stuhl', params:'Histamin (Stuhl)',
      desc_de:'Misst den Histamingehalt direkt im Stuhl – schneller und günstiger Einstieg.',
      desc_en:'Measures histamine directly in stool – quick and affordable entry test.' },
    { de:'SIBO – Atemtest Dünndarm', en:'SIBO – Small Intestine Breath Test', price:'€ 115,00', variantId:54971817132418, handle:'sibo',
      probe:'Atemluft', params:'Wasserstoff (H₂) · Methan (CH₄)',
      desc_de:'Erfasst bakterielles Überwachstum im Dünndarm durch Gasanalyse der Atemluft.',
      desc_en:'Detects bacterial overgrowth in the small intestine via breath gas analysis.' },
    { de:'Basisprofil Darm, Leaky Gut & Histamin', en:'Gut Microbiome, Leaky Gut & Histamine', price:'€ 257,50', variantId:54971331772802, handle:'basisprofil-darm-mikrobiom-leaky-gut-histamin',
      probe:'Stuhl', params:'Mikrobiom · Zonulin · Alpha-1-Antitrypsin · Calprotectin · DAO · Histamin',
      desc_de:'Umfassendes Darmprofil: Mikrobiom, Darmbarriere und Histamin in einem Test.',
      desc_en:'Comprehensive gut profile: microbiome, gut barrier and histamine in one test.' },
  ],
  haut: [
    { de:'Histamin- und DAO-Enzym Analyse', en:'Histamine & DAO Enzyme Analysis', price:'€ 84,50', variantId:54971644051842, handle:'histamin-und-dao-enzym-analyse',
      probe:'Blut & Stuhl', params:'DAO-Enzym · Histamin (Plasma)',
      desc_de:'Misst das histaminabbauende DAO-Enzym sowie Histamin im Blut.',
      desc_en:'Measures the histamine-degrading DAO enzyme and histamine in blood.' },
    { de:'Hautgesundheit-Basis', en:'Skin Health Basic', price:'€ 255,50', variantId:55856334471554, handle:'hautgesundheit-basis',
      probe:'Kapillarblut & Stuhl', params:'Zink · Vitamin D · Omega-3 · DAO · Histamin',
      desc_de:'Basisanalyse für Hautgesundheit: Nährstoffe, Histamin und Entzündungsmarker.',
      desc_en:'Basic skin health analysis: nutrients, histamine and inflammation markers.' },
    { de:'Hautgesundheit plus', en:'Skin Health Plus', price:'€ 475,00', variantId:55861673820546, handle:'hautgesundheit-plus',
      probe:'Kapillarblut & Stuhl', params:'Zink · Biotin · Selen · Mikrobiom · Hormone',
      desc_de:'Umfassendstes Hautprofil inkl. Mikrobiom, Hormone und Nährstoffe.',
      desc_en:'Most comprehensive skin profile incl. microbiome, hormones and nutrients.' },
  ],
  basic: [
    { de:'OM Vital Bluttest', en:'OM Vital Blood Test', price:'€ 185,50', variantId:54971346059650, handle:'om-vital-bluttest',
      probe:'Kapillarblut', params:'Vitamine · Mineralien · Blutbild · Schilddrüse · Entzündung',
      desc_de:'Basis-Blutanalyse: Vitamine, Mineralien und allgemeine Gesundheitsmarker.',
      desc_en:'Basic blood analysis: vitamins, minerals and general health markers.' },
    { de:'Prevent 360 – ORY Analysis Test', en:'Prevent 360 – ORY Analysis Test', price:'€ 295,00', variantId:55101088039298, handle:'prevent-360-ory-analysis-test',
      probe:'Kapillarblut', params:'75 Biomarker · Aminosäuren · Hormone · Darm · Energie',
      desc_de:'75 Biomarker aus Kapillarblut – umfassendstes Präventionsprofil von ORY.',
      desc_en:'75 biomarkers from capillary blood – most comprehensive prevention profile.' },
  ],
  longevity: [
    { de:'Prevent 360 – ORY Analysis Test', en:'Prevent 360 – ORY Analysis Test', price:'€ 295,00', variantId:55101088039298, handle:'prevent-360-ory-analysis-test',
      probe:'Kapillarblut', params:'75 Biomarker · Aminosäuren · Hormone · Darm · Energie',
      desc_de:'75 Biomarker aus Kapillarblut – umfassendstes Präventionsprofil von ORY.',
      desc_en:'75 biomarkers from capillary blood – most comprehensive prevention profile.' },
    { de:'Neurotransmitter Tryptophan Metabolismus Plus', en:'Neurotransmitter Tryptophan Metabol. Plus', price:'€ 340,70', variantId:55578484310402, handle:'tryptophan-metabolismus-test-plus',
      probe:'Urin', params:'Serotonin · Tryptophan · Kynurenin · 5-HIAA · Melatonin',
      desc_de:'Umfassendstes Neurotransmitter-Profil inkl. vollständigem Tryptophan-Stoffwechselweg.',
      desc_en:'Most comprehensive neurotransmitter profile incl. full tryptophan pathway.' },
    { de:'Mikrobiom Maxi Plus + Leaky Gut + Resorption', en:'Microbiome Maxi Plus + Leaky Gut', price:'€ 422,00', variantId:54971693990274, handle:'mikrobiom-maxi-plus-leaky-gut-resorption',
      probe:'Stuhl', params:'Mikrobiom · Leaky Gut · Resorption · sIgA · Entzündung',
      desc_de:'Maximales Darmprofil inkl. erweitertem Mikrobiom und Resorptionsparametern.',
      desc_en:'Maximum gut profile incl. extended microbiome and absorption parameters.' },
  ],
  sport: [
    { de:'Neurotransmitter Basis', en:'Neurotransmitter Basic', price:'€ 97,70', variantId:54971714601346, handle:'neurotransmitter-basis',
      probe:'Urin', params:'Adrenalin · Noradrenalin · Dopamin · Serotonin · GABA',
      desc_de:'Misst zentrale Stressbotenstoffe und Neurotransmitter im Urin.',
      desc_en:'Measures key stress messengers and neurotransmitters in urine.' },
    { de:'OM Vital Bluttest', en:'OM Vital Blood Test', price:'€ 185,50', variantId:54971346059650, handle:'om-vital-bluttest',
      probe:'Kapillarblut', params:'Vitamine · Mineralien · Blutbild · Schilddrüse · Entzündung',
      desc_de:'Basis-Blutanalyse: Vitamine, Mineralien und allgemeine Gesundheitsmarker.',
      desc_en:'Basic blood analysis: vitamins, minerals and general health markers.' },
    { de:'Prevent 360 – ORY Analysis Test', en:'Prevent 360 – ORY Analysis Test', price:'€ 295,00', variantId:55101088039298, handle:'prevent-360-ory-analysis-test',
      probe:'Kapillarblut', params:'75 Biomarker · Aminosäuren · Hormone · Darm · Energie',
      desc_de:'75 Biomarker aus Kapillarblut – umfassendstes Präventionsprofil von ORY.',
      desc_en:'75 biomarkers from capillary blood – most comprehensive prevention profile.' },
  ],
  naehr: [
    { de:'OM Vital Bluttest', en:'OM Vital Blood Test', price:'€ 185,50', variantId:54971346059650, handle:'om-vital-bluttest',
      probe:'Kapillarblut', params:'Vitamine · Mineralien · Blutbild · Schilddrüse · Entzündung',
      desc_de:'Basis-Blutanalyse: Vitamine, Mineralien und allgemeine Gesundheitsmarker.',
      desc_en:'Basic blood analysis: vitamins, minerals and general health markers.' },
    { de:'Prevent 360 – ORY Analysis Test', en:'Prevent 360 – ORY Analysis Test', price:'€ 295,00', variantId:55101088039298, handle:'prevent-360-ory-analysis-test',
      probe:'Kapillarblut', params:'75 Biomarker · Aminosäuren · Hormone · Darm · Energie',
      desc_de:'75 Biomarker aus Kapillarblut – umfassendstes Präventionsprofil von ORY.',
      desc_en:'75 biomarkers from capillary blood – most comprehensive prevention profile.' },
  ],
  schwermetalle: [
    { de:'Nitrostress – Nitrosativer Stress', en:'Nitrostress – Nitrosative Stress', price:'€ 89,00', variantId:54971778990466, handle:'nitrostress-nitrosativer-stress',
      probe:'Urin', params:'Nitrotyrosin · 3-Nitrotyrosin',
      desc_de:'Misst Belastung durch Stickstoffradikale und nitrosativen Zellstress.',
      desc_en:'Measures nitric oxide radical burden and nitrosative cell stress.' },
    { de:'Nitrosativer Stress – Zellstressprofil', en:'Nitrosative Stress – Cell Stress Profile', price:'€ 149,00', variantId:54971877097858, handle:'zellstressprofil',
      probe:'Urin & Blut', params:'Nitrotyrosin · MDA · 8-OHdG · GSH · SOD',
      desc_de:'Erweitertes Zellstressprofil inkl. oxidativer und nitrosativer Stressmarker.',
      desc_en:'Extended cell stress profile incl. oxidative and nitrosative stress markers.' },
  ],
  epi: [
    { de:'Epigenetik | Alterung', en:'Epigenetics | Aging', price:'', variantId:54971449016706, handle:'epigenetik-gesundes-altern',
      probe:'Kapillarblut', params:'DNA-Methylierung · Biologisches Alter · Zellalterung · Epigenetische Uhr · Entzündung',
      desc_de:'Epigenetischer Alterungstest: misst das biologische Alter auf Zellebene und zeigt individuelle Alterungsprozesse.',
      desc_en:'Epigenetic aging test: measures biological age at cell level and reveals individual ageing processes.' },
    { de:'Prevent 360 – ORY Analysis Test', en:'Prevent 360 – ORY Analysis Test', price:'€ 295,00', variantId:55101088039298, handle:'prevent-360-ory-analysis-test',
      probe:'Kapillarblut', params:'75 Biomarker · Aminosäuren · Hormone · Darm · Energie',
      desc_de:'75 Biomarker aus Kapillarblut – umfassendstes Präventionsprofil von ORY.',
      desc_en:'75 biomarkers from capillary blood – most comprehensive prevention profile.' },
    { de:'Mikrobiom Maxi Plus + Leaky Gut + Resorption', en:'Microbiome Maxi Plus + Leaky Gut', price:'€ 422,00', variantId:54971693990274, handle:'mikrobiom-maxi-plus-leaky-gut-resorption',
      probe:'Stuhl', params:'Mikrobiom · Leaky Gut · Resorption · sIgA · Entzündung',
      desc_de:'Maximales Darmprofil inkl. erweitertem Mikrobiom und Resorptionsparametern.',
      desc_en:'Maximum gut profile incl. extended microbiome and absorption parameters.' },
  ],
  // ─── Sportprofil (epigenetisch, für Sport & Training)
  sportprofil: [
    { de:'Epigenetik | Sport & Training', en:'Epigenetics | Sport & Training', price:'€ 354,94', variantId:54971453604226, handle:'epigenetik-sport-training',
      probe:'Kapillarblut', params:'MicroRNA · DNA-Stabilität · Entzündung · Mikronährstoffe · Epigenetik',
      desc_de:'Epigenetischer Sporttest: analysiert Regeneration, Leistung und Entzündungsmarker.',
      desc_en:'Epigenetic sport test: analyses recovery, performance and inflammation markers.' },
  ],
  // ─── Hormon-Profile
  hormon_f: [
    { de:'Hormonprofil Frau', en:'Female Hormone Profile', price:'€ 145,50', variantId:'54971646148994', handle:'hormonprofil-frau-mann', comingSoon:false,
      probe:'Speichel / Blut', params:'Östrogen · Progesteron · LH · FSH · DHEA',
      desc_de:'Umfassendes weibliches Hormonprofil inkl. Zyklushormone und DHEA.',
      desc_en:'Comprehensive female hormone profile incl. cycle hormones and DHEA.' },
  ],
  hormon_m: [
    { de:'Hormonprofil Mann', en:'Male Hormone Profile', price:'€ 145,50', variantId:'55537597874562', handle:'mann-hormonprofil-test', comingSoon:false,
      probe:'Speichel / Blut', params:'Testosteron · DHEA · LH · FSH · Cortisol',
      desc_de:'Männliches Hormonprofil inkl. Testosteron, DHEA und Stresshormone.',
      desc_en:'Male hormone profile incl. testosterone, DHEA and stress hormones.' },
  ],
};

/* ─── PAKETE – Komplett-Profile je Hauptthema ───────────────────────── */
const PACKAGES = {
  // schlaf-stress-paket noch nicht online → wird ergänzt sobald Paket live ist
  schlaf:        { de:'Schlafprobleme & Stress Diagnostik Paket',        en:'Sleep & Stress Diagnostics Package',       price:'€ 761,85',   handle:'schlaf-stress-paket',   comingSoon:true },
  energie:       { de:'Prevent 360 – ORY Analysis Test',                 en:'Prevent 360 – ORY Analysis Test',          price:'€ 295,00',   handle:'prevent-360-ory-analysis-test' },
  verdauung:     { de:'Basisprofil Darm, Leaky Gut & Histamin',           en:'Gut Microbiome, Leaky Gut & Histamine',    price:'€ 257,50',   handle:'basisprofil-darm-mikrobiom-leaky-gut-histamin' },
  haut:          { de:'Hautgesundheit plus',                              en:'Skin Health Plus',                         price:'€ 475,00',   handle:'hautgesundheit-plus' },
  stress:        { de:'Schlafprobleme & Stress Diagnostik Paket',        en:'Sleep & Stress Diagnostics Package',       price:'€ 761,85',   handle:'schlaf-stress-paket',   comingSoon:true },
  konzentration: { de:'Neurotransmitter Tryptophan Metabolismus Plus',    en:'Neurotransmitter Tryptophan Metabol. Plus',price:'€ 340,70',   handle:'tryptophan-metabolismus-test-plus' },
  sport:         { de:'Prevent 360 – ORY Analysis Test',                 en:'Prevent 360 – ORY Analysis Test',          price:'€ 295,00',   handle:'prevent-360-ory-analysis-test' },
  vorsorge:      { de:'Prevent 360 – ORY Analysis Test',                 en:'Prevent 360 – ORY Analysis Test',          price:'€ 295,00',   handle:'prevent-360-ory-analysis-test' },
  longevity:     { de:'Mikrobiom Maxi Plus + Leaky Gut + Resorption',    en:'Microbiome Maxi Plus + Leaky Gut',         price:'€ 422,00',   handle:'mikrobiom-maxi-plus-leaky-gut-resorption' },
};

/* ─── VERTIEFUNGS-PRODUKTREGELN ─────────────────────────────────────── */
// concIdx = Index der Antwort in s2fu.opts (0-basiert)
// Wenn Patient diese Option wählt → dieses Produkt bevorzugt empfehlen
const CONC_RULES = {
  schlaf: [
    { concIdx:0, areaId:'stress', handle:'cortisol-tagesprofil' },                          // Einschlafprobleme → Cortisol
    { concIdx:1, areaId:'neuro',  handle:'tryptophan-metabolismus-test-plus' },              // Durchschlafprobleme → Tryptophan/Serotonin
  ],
  verdauung: [
    { concIdx:0, areaId:'darm',   handle:'basisprofil-darm-mikrobiom-leaky-gut-histamin' },  // Unregelmäßige Verdauung → Basisprofil Darm
    { concIdx:1, areaId:'darm',   handle:'sibo' },                                  // Empfindliche Verdauung → SIBO Atemtest
    { concIdx:2, areaId:'darm',   handle:'sibo' },                                  // Blähungen → SIBO Atemtest
    { concIdx:3, areaId:'darm',   handle:'basisprofil-darm-mikrobiom-leaky-gut-histamin' },  // Bauchbeschwerden → Basisprofil Darm
  ],
  longevity: [
    { concIdx:2, areaId:'epi',    handle:'epigenetik-gesundes-altern' },  // Epigenetik & Zellgesundheit → Epigenetik | Alterung
  ],
};

/* ─── SCORING ────────────────────────────────────────────────────────── */
const SCORING = {
  schlaf:        { stress:3, neuro:3, basic:1, longevity:1, naehr:1 },
  energie:       { basic:3, naehr:3, sport:2, longevity:2, darm:1 },
  verdauung:     { darm:3, naehr:2, basic:1, longevity:1, schwermetalle:1 },
  haut:          { haut:3, basic:2, naehr:1 },
  stress:        { stress:3, neuro:3, basic:1, naehr:1 },
  konzentration: { neuro:3, stress:2, naehr:2, basic:1, epi:1 },
  sport:         { sport:3, basic:2, naehr:2, longevity:1 },
  vorsorge:      { basic:3, longevity:2, darm:1, naehr:1, schwermetalle:1 },
  longevity:     { longevity:3, epi:3, basic:2, neuro:1, naehr:1 },
};

/* Area labels */
const AREA_LABEL = {
  basic:        { de:'Basisdiagnostik',           en:'Basic Diagnostics' },
  darm:         { de:'Darm & Mikrobiom',           en:'Gut & Microbiome' },
  longevity:    { de:'Longevity Profil',           en:'Longevity Profile' },
  sport:        { de:'Sport & Performance',        en:'Sport & Performance' },
  stress:       { de:'Stress & Erschöpfung',       en:'Stress & Exhaustion' },
  neuro:        { de:'Neurotransmitter & Hormone', en:'Neurotransmitters & Hormones' },
  naehr:        { de:'Nährstoffe & Ernährung',     en:'Nutrients & Nutrition' },
  haut:         { de:'Hautgesundheit',             en:'Skin Health' },
  schwermetalle:{ de:'Zell- & Umweltbelastung',    en:'Cell & Environmental Load' },
  epi:          { de:'Epigenetik & Aging',         en:'Epigenetics & Aging' },
};

/* ─── ALTERSGRUPPEN ──────────────────────────────────────────────────── */
const AGE_GROUPS = [
  { id:'u25',   de:'Unter 25',  en:'Under 25',  de_sub:'Junges Erwachsenenalter',        en_sub:'Young adulthood' },
  { id:'a2535', de:'25 – 35',   en:'25 – 35',   de_sub:'Aktive Lebensphase',             en_sub:'Peak adult years' },
  { id:'a3645', de:'36 – 45',   en:'36 – 45',   de_sub:'Erste hormonelle Veränderungen', en_sub:'First hormonal changes' },
  { id:'a4655', de:'46 – 55',   en:'46 – 55',   de_sub:'Hormonelle Transition',          en_sub:'Hormonal transition' },
  { id:'a5665', de:'56 – 65',   en:'56 – 65',   de_sub:'Prävention & Vitalität',         en_sub:'Prevention & vitality' },
  { id:'o65',   de:'Über 65',   en:'Over 65',   de_sub:'Longevity & Seniorengesundheit', en_sub:'Longevity & senior health' },
];

/* ─── TRANSLATIONS ───────────────────────────────────────────────────── */
const TX = {
  de: {
    back:'← Zurück', next:'Weiter', start:'Quiz starten', submit:'Konto erstellen',
    multiHint:'Mehrfachauswahl möglich',

    sgTag:'Dein Profil', sgH:'Damit wir dich besser begleiten können',
    sgP:'Eine kurze Angabe hilft uns, die richtigen Analysen für dich zusammenzustellen.',
    sgFemale:'Frau', sgMale:'Mann', sgOther:'Divers / Keine Angabe',
    sgDiversNote:'Laborwerte wie Hormone, Hämoglobin und Kreatinin werden anhand des biologischen Geschlechts ausgewertet – unabhängig von der Geschlechtsidentität. Damit deine Ergebnisse korrekt eingeordnet werden können, benötigen wir folgende Angabe:',
    sgBioSexH:'Biologisches Geschlecht (für die Laborauswertung):',
    sgBioFemale:'Biologisch weiblich',
    sgBioMale:'Biologisch männlich',
    sgHormonHint: g => g==='female'
      ? 'Als Frau können wir dir ergänzend ein Hormonprofil (Östrogen, Progesteron) empfehlen.'
      : 'Als Mann können wir dir ergänzend ein Hormonprofil (Testosteron) empfehlen.',
    sgHormonLabel:'Hormonelle Ergänzung',
    sgHormonSoon:'Demnächst verfügbar',

    saTag:'Deine Altersgruppe', saH:'In welche Altersgruppe fällst du?',
    saP:'Dein Alter hilft uns, die medizinisch relevantesten Analysen für deine aktuelle Lebensphase auszuwählen.',
    saGroups: AGE_GROUPS,

    s0tag:'Willkommen', s0h:'Finde deinen Analysebereich',
    s0p:'Dieses Quiz hilft dir, relevante Analysebereiche für deine persönlichen Gesundheitsziele kennenzulernen.',
    s0disc:'Dieses Quiz dient ausschließlich der allgemeinen Orientierung. Es werden keine Diagnosen gestellt und keine medizinischen Empfehlungen gegeben.',

    s1tag:'Deine Themen', s1h:'Welche Themen stehen bei dir aktuell im Fokus?',
    s1p:'Wähle alle Bereiche aus, die dich beschäftigen.',
    s1opts:[
      {id:'schlaf',        l:'Schlaf & Regeneration'},
      {id:'energie',       l:'Energie & Leistungsfähigkeit'},
      {id:'verdauung',     l:'Verdauung & Bauchgefühl'},
      {id:'haut',          l:'Haut & äußeres Erscheinungsbild'},
      {id:'stress',        l:'Stress & innere Balance'},
      {id:'konzentration', l:'Konzentration & mentale Klarheit'},
      {id:'sport',         l:'Sport & körperliche Leistungsfähigkeit'},
      {id:'vorsorge',      l:'Allgemeine Gesundheitsvorsorge'},
      {id:'longevity',     l:'Prävention & Longevity'},
    ],

    s2tag:'Vertiefung', s2h:'Welche Aspekte sind für dich besonders relevant?',
    s2p:'Wähle, was auf dich am ehesten zutrifft.',
    s2fu:{
      schlaf:        { q:'Was beschäftigt dich beim Thema Schlaf?',           opts:['Einschlafprobleme – ich komme schwer zur Ruhe','Durchschlafprobleme – ich wache oft auf','Innere Unruhe & Anspannung am Abend','Erschöpfung trotz Schlaf – schlechte Erholung'] },
      energie:       { q:'Was ist dir beim Thema Energie wichtig?',           opts:['Nachmittäglicher Energieabfall','Allgemeine Vitalität','Sportliche Ausdauer','Nährstoffversorgung'] },
      verdauung:     { q:'Was beschäftigt dich beim Thema Verdauung?',        opts:['Unregelmäßige Verdauung – seltener, fester Stuhlgang','Empfindliche Verdauung – häufig weicher Stuhlgang','Blähungen & Völlegefühl nach dem Essen','Bauchbeschwerden & Krämpfe'] },
      haut:          { q:'Was ist dir beim Thema Haut wichtig?',              opts:['Hautbild & Erscheinung','Verträglichkeit von Produkten','Innere Ursachen erforschen','Allgemeines Wohlbefinden'] },
      stress:        { q:'Was beschäftigt dich beim Thema Stress?',           opts:['Innere Anspannung','Erschöpfungsgefühl','Konzentration & Fokus','Allgemeine Balance'] },
      konzentration: { q:'Was interessiert dich beim Thema mentale Klarheit?',opts:['Fokus im Alltag','Gedächtnis & Abrufen','Stimmung & Ausgeglichenheit','Neurotransmitter & Botenstoffe'] },
      sport:         { q:'Was ist dir beim Thema Sport wichtig?',             opts:['Ausdauer & Leistung','Regeneration nach Sport','Nährstoffversorgung','Verletzungsprävention'] },
      vorsorge:      { q:'Was interessiert dich bei der Gesundheitsvorsorge?',opts:['Basiswerte kennen','Früherkennung','Umfassender Überblick','Jährliche Kontrolle'] },
      longevity:     { q:'Was beschäftigt dich beim Thema Longevity?',        opts:['Biologisches Alter verstehen','Präventive Maßnahmen','Epigenetik & Zellgesundheit','Langfristige Vitalität'] },
    },

    s3tag:'Deine Situation', s3h:'Wie intensiv ist das Thema für dich?',
    s3p:'Drei kurze Fragen – deine Antworten bestimmen die Tiefe deiner Auswertung.',
    stepOf:(n,t)=>`Frage ${n} von ${t}`,
    s3intensity_q:'Wie stark beschäftigt dich das Thema aktuell?',
    s3intensity:[ {v:1,l:'Es interessiert\nmich'}, {v:2,l:'Es liegt mir\nam Herzen'}, {v:3,l:'Es beschäftigt\nmich sehr'} ],
    s3duration_q:'Wie lange ist das schon ein Thema für dich?',
    s3duration:[ {v:1,l:'Erst kürzlich\naufgekommen'}, {v:2,l:'Seit einigen\nMonaten'}, {v:3,l:'Schon\nlänger'} ],
    s3engagement_q:'Wie viel möchtest du dafür unternehmen?',
    s3engagement:[ {v:1,l:'Erst einmal\ninformieren'}, {v:2,l:'Aktiv\nangehen'}, {v:3,l:'Umfassend\nklären'} ],

    s4tag:'Deine Ergebnisse', s4h:'Deine Produktempfehlungen',
    s4p:'Basierend auf deinen Angaben haben wir konkrete Analyseprodukte für dich zusammengestellt.',
    depthLabels:['Allgemeine Orientierung','Gezielte Orientierung','Umfassende Orientierung'],
    /* Priority badges – [high burden, prevention] × [rank 0,1,2] */
    prio_high: ['★★★ Zentral wichtig', '★★ Auch wichtig', '★ Ergänzend'],
    prio_prev: ['★★★ Empfohlen',       '★★ Ergänzend',    '★ Gute Orientierung'],
    cartLabel:'Ausgewählt für den Warenkorb',
    cartCount:(n)=>`${n} Produkt${n!==1?'e':''} ausgewählt`,
    removeBtn:'Aus Bestellung entfernen',
    restoreBtn:'Zur Bestellung hinzufügen',
    viewProduct:'Produkt ansehen →',
    viewSample:'Musterbefund ansehen →',
    cartAllBtn:'Alle ausgewählten bestellen',
    continueBtn:'Weiter zur Anmeldung →',
    pkgLabel:'Komplett-Analyse für diesen Bereich',
    pkgLabelAlt:'Weitere Option: Komplettpaket',
    pkgSub:'Alle relevanten Marker in einem Profil zusammengefasst.',
    pkgBtn:'Paket ansehen →',
    pkgPriceLabel:'Paketpreis',
    rcoaching_q:'Noch unsicher, wo du anfangen sollst?',
    rcoaching_btn:'Kostenlose Beratung buchen',

    s5tag:'Anmeldung & Befragungsergebnisse', s5h:'Anmelden & Befragungsergebnisse per E-Mail erhalten',
    s5p:'Melde dich an und erhalte deine Befragungsergebnisse mit den empfohlenen Analysen und direkten Bestelllinks — so kannst du jederzeit bestellen.',
    s5email:'E-Mail-Adresse *', s5first:'Vorname *', s5last:'Nachname *', s5dob:'Geburtsdatum *',
    s5dobNote:'Dein Geburtsdatum ist für die medizinische Auswertung deiner Analyseergebnisse erforderlich.',
    s5emailPh:'deine@email.de', s5firstPh:'Vorname', s5lastPh:'Nachname',
    s5consent:'Ich stimme zu, Informationen per E-Mail zu erhalten. Meine Daten werden gemäß der Datenschutzerklärung von ORY Berlin verarbeitet.',
    s5emailResults:'Befragungsergebnisse an meine E-Mail schicken – ich möchte später bestellen können.',
    s5phone:'Telefonnummer', s5phonePh:'+49 ...',
    s5callback:'Bitte ruf mich für eine Expressberatung zurück.',
    s5privacy:'Wir respektieren deine persönlichen Daten und geben sie nicht an Dritte weiter.',

    s6h:'Vielen Dank!',
    s6p:'Deine Befragungsergebnisse wurden gesendet. Wir melden uns in Kürze.\n\nDu erhältst deine empfohlenen Analysen mit Bestelllinks per E-Mail.',
    s6cart:'Warenkorb ansehen',
    s6shop:'Zum ORY-Shop',
    legal:'Diese Übersicht dient der allgemeinen Orientierung und stellt keine Diagnose dar.',
  },

  en: {
    back:'← Back', next:'Continue', start:'Start quiz', submit:'Create account',
    multiHint:'Multiple selections possible',

    sgTag:'Your profile', sgH:'So we can guide you better',
    sgP:'A quick detail helps us compile the right analyses for you.',
    sgFemale:'Female', sgMale:'Male', sgOther:'Diverse / Prefer not to say',
    sgDiversNote:'Lab values such as hormones, haemoglobin, and creatinine are evaluated based on biological sex – independent of gender identity. To ensure your results are correctly interpreted, we need the following information:',
    sgBioSexH:'Biological sex (for lab evaluation):',
    sgBioFemale:'Biological female',
    sgBioMale:'Biological male',
    sgHormonHint: g => g==='female'
      ? 'As a woman we can additionally recommend a hormone profile (oestrogen, progesterone).'
      : 'As a man we can additionally recommend a hormone profile (testosterone).',
    sgHormonLabel:'Hormonal add-on',
    sgHormonSoon:'Coming soon',

    saTag:'Your age group', saH:'Which age group do you belong to?',
    saP:'Your age helps us select the most medically relevant analyses for your current stage of life.',
    saGroups: AGE_GROUPS,

    s0tag:'Welcome', s0h:'Find your analysis focus',
    s0p:'This quiz helps you discover relevant analysis areas for your personal health goals.',
    s0disc:'This quiz is for general orientation only. No diagnoses are made and no medical recommendations are given.',

    s1tag:'Your topics', s1h:'Which topics are currently on your mind?',
    s1p:'Select all areas that interest you.',
    s1opts:[
      {id:'schlaf',        l:'Sleep & Recovery'},
      {id:'energie',       l:'Energy & Performance'},
      {id:'verdauung',     l:'Digestion & Gut Feeling'},
      {id:'haut',          l:'Skin & Appearance'},
      {id:'stress',        l:'Stress & Inner Balance'},
      {id:'konzentration', l:'Concentration & Mental Clarity'},
      {id:'sport',         l:'Sport & Physical Performance'},
      {id:'vorsorge',      l:'General Health Prevention'},
      {id:'longevity',     l:'Prevention & Longevity'},
    ],

    s2tag:'More detail', s2h:'Which aspects are most relevant to you?',
    s2p:'Select what applies to you most.',
    s2fu:{
      schlaf:        { q:'What concerns you about sleep?',                  opts:['Trouble falling asleep – hard to wind down','Trouble staying asleep – waking up often','Inner tension & restlessness in the evening','Exhaustion despite sleep – poor recovery'] },
      energie:       { q:'What is important to you regarding energy?',       opts:['Afternoon energy slump','General vitality','Athletic endurance','Nutrient supply'] },
      verdauung:     { q:'What concerns you about digestion?',               opts:['Irregular digestion – infrequent, hard stools','Sensitive digestion – frequently loose stools','Bloating & fullness after eating','Abdominal discomfort & cramps'] },
      haut:          { q:'What matters to you regarding skin?',              opts:['Complexion & appearance','Product tolerability','Exploring internal causes','General well-being'] },
      stress:        { q:'What concerns you about stress?',                  opts:['Inner tension','Feeling of exhaustion','Concentration & focus','General balance'] },
      konzentration: { q:'What interests you about mental clarity?',        opts:['Daily focus','Memory & recall','Mood & balance','Neurotransmitters'] },
      sport:         { q:'What matters to you about sport?',                 opts:['Endurance & performance','Recovery after sport','Nutrient supply','Injury prevention'] },
      vorsorge:      { q:'What interests you about health prevention?',     opts:['Knowing baseline values','Early detection','Comprehensive overview','Annual check-up'] },
      longevity:     { q:'What concerns you about longevity?',              opts:['Understanding biological age','Preventive measures','Epigenetics & cell health','Long-term vitality'] },
    },

    s3tag:'Your situation', s3h:'How significant is this topic for you?',
    s3p:'Three quick questions – your answers shape the depth of your results.',
    stepOf:(n,total)=>`Question ${n} of ${total}`,
    s3intensity_q:'How strongly does this topic concern you right now?',
    s3intensity:[ {v:1,l:'It interests\nme'}, {v:2,l:'It matters\nto me'}, {v:3,l:'It concerns\nme deeply'} ],
    s3duration_q:'How long has this been a topic for you?',
    s3duration:[ {v:1,l:'Just\nrecently'}, {v:2,l:'For a few\nmonths'}, {v:3,l:'For quite\nsome time'} ],
    s3engagement_q:'How much would you like to do about it?',
    s3engagement:[ {v:1,l:'Just get\ninfo first'}, {v:2,l:'Actively\naddress it'}, {v:3,l:'Clarify\ncomprehensively'} ],

    s4tag:'Your results', s4h:'Your product recommendations',
    s4p:'Based on your answers, we have compiled concrete analysis products for you.',
    depthLabels:['General orientation','Targeted orientation','Comprehensive orientation'],
    prio_high: ['★★★ Essential',      '★★ Also important', '★ Supplementary'],
    prio_prev: ['★★★ Recommended',    '★★ Supplementary',  '★ For orientation'],
    cartLabel:'Selected for cart',
    cartCount:(n)=>`${n} product${n!==1?'s':''} selected`,
    removeBtn:'Remove from order',
    restoreBtn:'Add to order',
    viewProduct:'View product →',
    viewSample:'View sample report →',
    cartAllBtn:'Order all selected',
    continueBtn:'Continue to sign up →',
    pkgLabel:'Comprehensive analysis for this area',
    pkgLabelAlt:'Further option: Complete package',
    pkgSub:'All relevant markers combined in one profile.',
    pkgBtn:'View package →',
    pkgPriceLabel:'Package price',
    rcoaching_q:'Not sure where to start?',
    rcoaching_btn:'Book a free consultation',

    s5tag:'Sign up & survey results', s5h:'Sign up & receive your survey results by email',
    s5p:'Sign up and receive your personalised analysis recommendations with direct order links — so you can order whenever you are ready.',
    s5email:'Email address *', s5first:'First name *', s5last:'Last name *', s5dob:'Date of birth *',
    s5dobNote:'Your date of birth is required for the medical evaluation of your analysis results.',
    s5emailPh:'your@email.com', s5firstPh:'First name', s5lastPh:'Last name',
    s5consent:'I agree to receive information by email. My data is processed per the ORY Berlin privacy policy.',
    s5emailResults:'Send my survey results to my email – I would like to order later.',
    s5phone:'Phone number', s5phonePh:'+49 ...',
    s5callback:'Please call me back for an express consultation.',
    s5privacy:'We respect your personal data and do not share it with third parties.',

    s6h:'Thank you!',
    s6p:'Your evaluation has been saved. We will contact you by email shortly.\n\nYour selected products are in the cart.',
    s6cart:'View cart',
    s6shop:'Go to ORY Shop',
    legal:'This overview is for general orientation only and does not constitute a diagnosis.',
  }
};

/* ─── STATE ──────────────────────────────────────────────────────────── */
let S = {
  lang:'de', step:0,
  topics:[], conc:{},
  intensity:0, duration:0, engagement:0,
  gender:'',  // 'female' | 'male' | 'other'
  bioSex:'',  // 'female' | 'male' — nur wenn gender==='other', für Referenzwert-Zuordnung
  age:'',     // 'u25' | 'a2535' | 'a3645' | 'a4655' | 'a5665' | 'o65'
  email:'', first:'', last:'', dob:'', phone:'', consent:false,
  removed: new Set(),   // product unique keys removed from cart
  productList: [],      // built when results render
  hormonOpt: false,     // user explicitly opted into hormone add-on
  emailResults: false,  // patient wants results by email
  callback: false,      // patient requests callback
};

/* ─── HELPERS ────────────────────────────────────────────────────────── */
const t  = () => TX[S.lang];
const $  = id => document.getElementById(id);

function depthScore()  { return S.intensity + S.duration + S.engagement; }
function resultCount() { const d=depthScore(); return d<=4?1:d<=6?2:3; }
function depthLabel()  { return t().depthLabels[resultCount()-1]; }
function isHighBurden(){ return S.engagement >= 2; }
function isHighLoad()  { return [S.intensity,S.duration,S.engagement].filter(v=>v===3).length >= 2; }

function buildResultSummary() {
  const l = t();
  const labels = S.topics.slice(0,3).map(tid => {
    const o = l.s1opts.find(x => x.id === tid);
    return o ? `<strong>${o.l}</strong>` : tid;
  });
  const joined = labels.length === 1
    ? labels[0]
    : labels.slice(0,-1).join(', ') + (S.lang==='de' ? ' und ' : ' and ') + labels[labels.length-1];
  if (S.lang === 'de') {
    const burden = isHighBurden() ? 'einer spürbaren Belastung' : 'einem allgemeinen Interesse';
    return `Du hast ${joined} als dein${labels.length>1?'e Themen':' Thema'} angegeben und sprichst von ${burden}. Basierend auf deiner Auswertung (<em>${depthLabel()}</em>) haben wir folgende Analysen für dich zusammengestellt:`;
  } else {
    const burden = isHighBurden() ? 'a noticeable concern' : 'a general interest';
    return `You selected ${joined} as your ${labels.length>1?'topics':'topic'} and indicated ${burden}. Based on your evaluation (<em>${depthLabel()}</em>), we have compiled the following analyses for you:`;
  }
}

function calcAreas() {
  const scores = {};
  S.topics.forEach(tid => {
    Object.entries(SCORING[tid]||{}).forEach(([aid,w]) => { scores[aid]=(scores[aid]||0)+w; });
  });
  return Object.entries(scores).sort((a,b)=>b[1]-a[1]).slice(0,resultCount()).map(([id])=>id);
}

/* Which product tier to show: 0=klein, 1=mittel, 2=groß – based on depth */
function productTier() {
  const d = depthScore();
  return d <= 4 ? 0 : d <= 6 ? 1 : 2;
}

/* Build deduplicated product list – max 3 products total
   Single area → 2 products (primär ★★★ + sekundär ★★)
   Multiple areas → 1 product per area */
function buildProductList() {
  const areas = calcAreas();
  const tier = productTier();
  const list = [];
  const seenHandles = new Set();

  if (areas.length === 1) {
    const prods = PRODUCTS[areas[0]] || [];
    const t1 = Math.min(tier, prods.length - 1);
    const t2 = t1 > 0 ? t1 - 1 : Math.min(t1 + 1, prods.length - 1);
    [t1, t2].forEach((t, rankIdx) => {
      const p = prods[t];
      if (!p || seenHandles.has(p.handle)) return;
      seenHandles.add(p.handle);
      list.push({ key: `${areas[0]}-${rankIdx}`, areaId: areas[0], rank: rankIdx, ...p });
    });
  } else {
    areas.forEach((areaId, areaIdx) => {
      const prods = PRODUCTS[areaId] || [];
      const p = prods[Math.min(tier, prods.length - 1)];
      if (!p || seenHandles.has(p.handle)) return;
      seenHandles.add(p.handle);
      list.push({ key: `${areaId}-${areaIdx}`, areaId, rank: areaIdx, ...p });
    });
  }

  // ── Vertiefungs-Produktregeln anwenden ──────────────────────────────
  Object.entries(S.conc).forEach(([tid, selectedIdxs]) => {
    (CONC_RULES[tid] || []).forEach(rule => {
      if (!selectedIdxs.includes(rule.concIdx)) return;
      if (seenHandles.has(rule.handle)) return;
      const prod = (PRODUCTS[rule.areaId] || []).find(p => p.handle === rule.handle);
      if (!prod) return;
      const entry = { key:`${rule.areaId}-conc-${rule.concIdx}`, areaId:rule.areaId, rank:0, ...prod };
      if (list.length < 3) { list.unshift(entry); }
      else { list[list.length - 1] = entry; }
      seenHandles.add(rule.handle);
      list.forEach((p, i) => { p.rank = i; });
    });
  });

  // ── Kombi-Tiefenregeln ───────────────────────────────────────────────
  // Hormonprofil wird NICHT automatisch in productList aufgenommen –
  // User wählt es selbst über den Toggle in der Hormonbox (S.hormonOpt).

  // Verdauung + lange Beschwerden (duration≥2) + tiefer Wunsch (engagement≥2)
  // → Darmcheck-up UND SIBO gemeinsam anbieten
  if (S.topics.includes('verdauung') && S.duration >= 2 && S.engagement >= 2) {
    const kombi = [
      { areaId:'darm', handle:'basisprofil-darm-mikrobiom-leaky-gut-histamin' },
      { areaId:'darm', handle:'sibo' },
    ];
    kombi.forEach(rule => {
      if (seenHandles.has(rule.handle)) return;
      const prod = (PRODUCTS[rule.areaId] || []).find(p => p.handle === rule.handle);
      if (!prod) return;
      const entry = { key:`${rule.areaId}-kombi`, areaId:rule.areaId, rank:list.length, ...prod };
      if (list.length < 3) { list.push(entry); }
      else { list[list.length - 1] = entry; }
      seenHandles.add(rule.handle);
    });
    list.forEach((p, i) => { p.rank = i; });
  }

  return list;
}

function selectedProducts() {
  return S.productList.filter(p => !S.removed.has(p.key));
}

function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }
function leadOk()      { return validEmail(S.email)&&S.first.trim()&&S.last.trim()&&S.dob&&S.consent; }
function depthReady()  { return S.intensity>0&&S.duration>0&&S.engagement>0; }

function stepInfo() {
  // Steps: 0=Intro, 1=Gender, 2=Age, 3=Topics, 4=Concretize, 5=Depth, 6=Results, 7=Lead, 8=Confirm
  if (S.step === 0 || S.step >= 8) return null;
  const hasConcr = S.topics.length > 0 && S.topics.some(id => t().s2fu[id]);
  // Numbered: 1=Geschlecht, 2=Altersgruppe, 3=Themen, [4=Vertiefung], Tiefe, Ergebnisse, Anmeldung
  const total = hasConcr ? 7 : 6;
  const map = hasConcr
    ? {1:1, 2:2, 3:3, 4:4, 5:5, 6:6, 7:7}
    : {1:1, 2:2, 3:3, 4:3, 5:4, 6:5, 7:6};  // concretize skipped → depth bleibt 4
  const num = map[S.step] ?? S.step;
  return { num, total };
}

function setProgress(step) {
  const info     = stepInfo();
  const lbl      = $('stepLabel');
  const dots     = $('stepDots');
  const progFill = $('progFill');

  if (!info) {
    if (lbl)      lbl.textContent = '';
    if (dots)     dots.innerHTML  = '';
    if (progFill) progFill.style.width = step === 0 ? '0%' : '100%';
    return;
  }

  const label = S.lang === 'de'
    ? `Schritt ${info.num} / ${info.total}`
    : `Step ${info.num} / ${info.total}`;
  if (lbl) lbl.textContent = label;

  if (dots) {
    dots.innerHTML = Array.from({length: info.total}, (_, i) => {
      const cls = i + 1 < info.num ? 'done' : i + 1 === info.num ? 'active' : '';
      return `<span class="step-dot ${cls}"></span>`;
    }).join('');
  }

  if (progFill) progFill.style.width = Math.round((info.num / info.total) * 100) + '%';
}

function transition(fn) {
  const c=$('card'); c.classList.add('fade');
  setTimeout(()=>{ fn(); c.classList.remove('fade'); window.scrollTo({top:0,behavior:'smooth'}); },240);
}

/* ─── SCALE BARS ─────────────────────────────────────────────────────── */
function scaleBars(level) {
  return [6,11,16].map((h,i)=>`<span style="height:${h}px${i>=level?';opacity:.2':''}"></span>`).join('');
}
function scaleBtn(item, group, selected) {
  const on = selected===item.v?' on':'';
  return `<button class="scale-btn${on}" onclick="setDepth('${group}',${item.v},this)">
    <div class="scale-bars">${scaleBars(item.v)}</div>
    <div class="scale-label">${item.l.replace('\n','<br>')}</div>
  </button>`;
}

/* ─── RENDER ─────────────────────────────────────────────────────────── */
function render() {
  setProgress(S.step);
  const fns = [rIntro,rGender,rAge,rTopics,rConcretize,rDepth,rResults,rLead,rConfirm];
  $('card').innerHTML = fns[Math.min(S.step,8)]();
}

function rGender() {
  const l = t();
  const opts = [
    { id:'female', label:l.sgFemale, icon:'♀' },
    { id:'male',   label:l.sgMale,   icon:'♂' },
    { id:'other',  label:l.sgOther,  icon:'◎' },
  ];

  const bioSexPanel = S.gender === 'other' ? `
    <div class="bio-sex-panel">
      <p class="bio-sex-note">${l.sgDiversNote}</p>
      <p class="bio-sex-note" style="font-weight:600;margin-bottom:10px;">${l.sgBioSexH}</p>
      <div class="bio-sex-grid">
        <button class="bio-sex-btn${S.bioSex==='female'?' on':''}"
          onclick="S.bioSex='female';render()">♀ ${l.sgBioFemale}</button>
        <button class="bio-sex-btn${S.bioSex==='male'?' on':''}"
          onclick="S.bioSex='male';render()">♂ ${l.sgBioMale}</button>
      </div>
    </div>` : '';

  const canNext = S.gender && (S.gender !== 'other' || S.bioSex);

  return `
    <div class="tag">${l.sgTag}</div>
    <h2>${l.sgH}</h2>
    <p class="sub">${l.sgP}</p>
    <div class="gender-grid">
      ${opts.map(o => `
        <button class="gender-btn${S.gender===o.id?' on':''}"
          onclick="S.gender='${o.id}';${o.id!=='other'?'S.bioSex=\'\';':''}render()">
          <span class="gender-icon">${o.icon}</span>
          <span>${o.label}</span>
        </button>`).join('')}
    </div>
    ${bioSexPanel}
    <div class="nav">
      <button class="btn btn-ghost" onclick="back()">${l.back}</button>
      <button class="btn btn-p" onclick="next()" ${canNext?'':'disabled'}>${l.next}</button>
    </div>`;
}

function rAge() {
  const l = t();
  const lang = S.lang;
  return `
    <div class="tag">${l.saTag}</div>
    <h2>${l.saH}</h2>
    <p class="sub">${l.saP}</p>
    <div class="age-grid">
      ${AGE_GROUPS.map(g => `
        <button class="age-btn${S.age===g.id?' on':''}" onclick="S.age='${g.id}';render()">
          <span class="age-range">${lang==='de'?g.de:g.en}</span>
          <span class="age-sub">${lang==='de'?g.de_sub:g.en_sub}</span>
        </button>`).join('')}
    </div>
    <div class="nav">
      <button class="btn btn-ghost" onclick="back()">${l.back}</button>
      <button class="btn btn-p" onclick="next()" ${S.age?'':'disabled'}>${l.next}</button>
    </div>`;
}

function rIntro() {
  const l=t();
  return `<div class="tag">${l.s0tag}</div><h2>${l.s0h}</h2><p class="sub">${l.s0p}</p>
    <div class="disclaimer">${l.s0disc}</div>
    <button class="btn btn-p" onclick="next()">${l.start}</button>`;
}

function rTopics() {
  const l=t();
  return `<div class="tag">${l.s1tag}</div><h2>${l.s1h}</h2><p class="sub">${l.s1p}</p>
    <p class="hint">${l.multiHint}</p>
    <div class="grid">
      ${l.s1opts.map(o=>`
        <button class="opt${S.topics.includes(o.id)?' on':''}" onclick="toggleTopic('${o.id}',this)">
          <span class="dot"></span>${o.l}</button>`).join('')}
    </div>
    <div class="nav">
      <button class="btn btn-ghost" onclick="back()">${l.back}</button>
      <button class="btn btn-p" id="nb" onclick="next()" ${S.topics.length===0?'disabled':''}>${l.next}</button>
    </div>`;
}

function rConcretize() {
  const l=t();
  const rel=S.topics.filter(id=>l.s2fu[id]).slice(0,3);
  if(!rel.length){S.step++;return rDepth();}
  return `<div class="tag">${l.s2tag}</div><h2>${l.s2h}</h2><p class="sub">${l.s2p}</p>
    ${rel.map(tid=>{
      const fu=l.s2fu[tid]; const sel=S.conc[tid]||[];
      return `<div class="con-block"><div class="con-q">${fu.q}</div><div class="list">
        ${fu.opts.map((o,i)=>`
          <button class="opt${sel.includes(i)?' on':''}" onclick="toggleConc('${tid}',${i},this)">
            <span class="dot"></span>${o}</button>`).join('')}
        </div></div>`;
    }).join('')}
    <div class="nav">
      <button class="btn btn-ghost" onclick="back()">${l.back}</button>
      <button class="btn btn-p" onclick="next()">${l.next}</button>
    </div>`;
}

function rDepth() {
  const l=t();
  return `<div class="tag">${l.s3tag}</div><h2>${l.s3h}</h2><p class="sub">${l.s3p}</p>
    <div class="depth-block">
      <div class="depth-meta"><div class="depth-q">${l.s3intensity_q}</div><div class="depth-num">${l.stepOf(1,3)}</div></div>
      <div class="scale">${l.s3intensity.map(it=>scaleBtn(it,'intensity',S.intensity)).join('')}</div>
    </div>
    <div class="depth-block">
      <div class="depth-meta"><div class="depth-q">${l.s3duration_q}</div><div class="depth-num">${l.stepOf(2,3)}</div></div>
      <div class="scale">${l.s3duration.map(it=>scaleBtn(it,'duration',S.duration)).join('')}</div>
    </div>
    <div class="depth-block">
      <div class="depth-meta"><div class="depth-q">${l.s3engagement_q}</div><div class="depth-num">${l.stepOf(3,3)}</div></div>
      <div class="scale">${l.s3engagement.map(it=>scaleBtn(it,'engagement',S.engagement)).join('')}</div>
    </div>
    <div class="nav">
      <button class="btn btn-ghost" onclick="back()">${l.back}</button>
      <button class="btn btn-p" id="nb" onclick="next()" ${!depthReady()?'disabled':''}>${l.next}</button>
    </div>`;
}

function rResults() {
  const l = t();

  // Build product list once
  if (!S.productList.length) {
    S.productList = buildProductList();
    S.removed.clear();
  }

  const areas = calcAreas();
  const highBurden = isHighBurden();
  const prioLabels = highBurden ? l.prio_high : l.prio_prev;

  // Group by area for rendering
  const byArea = {};
  S.productList.forEach(p => {
    if (!byArea[p.areaId]) byArea[p.areaId] = [];
    byArea[p.areaId].push(p);
  });

  const totalSelected = selectedProducts().length + (S.hormonOpt ? 1 : 0);

  const pkgHtml = (() => {
    if (!isHighLoad()) return '';
    const topTopic = S.topics[0];
    const pkg = PACKAGES[topTopic];
    if (!pkg) return '';
    if (S.productList.some(p => p.handle === pkg.handle)) return '';
    const name = S.lang === 'de' ? pkg.de : pkg.en;
    const pkgBtn = pkg.comingSoon
      ? `<span class="btn-pkg btn-pkg-soon">${S.lang==='de'?'Demnächst verfügbar':'Coming soon'}</span>`
      : `<a class="btn-pkg" href="${SHOP}/products/${pkg.handle}" target="_blank">${l.pkgBtn}</a>`;
    return `
      <div class="pkg-box${pkg.comingSoon?' pkg-soon':''}">
        <div class="pkg-box-top">
          <div>
            <div class="pkg-box-label">${l.pkgLabelAlt}${pkg.comingSoon?` <span class="soon-badge">${S.lang==='de'?'Bald verfügbar':'Coming soon'}</span>`:''}</div>
            <div class="pkg-box-name">${name}</div>
          </div>
          <div class="pkg-box-price">${pkg.price}</div>
        </div>
        <div class="pkg-box-sub">${l.pkgSub}</div>
        ${pkgBtn}
      </div>`;
  })();

  return `
    <div class="tag">${l.s4tag}</div>
    <h2>${l.s4h}</h2>
    <p class="sub res-summary">${buildResultSummary()}</p>

    <div class="res-meta">
      <span class="cart-summary" id="cartCount">${l.cartCount(totalSelected)}</span>
    </div>

    ${areas.filter(areaId => (byArea[areaId] || []).length > 0).map(areaId => {
      const areaName = AREA_LABEL[areaId]?.[S.lang] || areaId;
      const prods = byArea[areaId] || [];
      return `
        <div class="area-header">${areaName}</div>
        ${prods.map(p => {
          const removed = S.removed.has(p.key);
          const prioIdx = Math.min(p.rank, 2);
          const prioClass = `prio-${prioIdx+1}`;
          const prioText = prioLabels[prioIdx] || prioLabels[2];
          return `
            <div class="prod-card${removed?' removed':''}" id="pc-${p.key}">
              <button class="prod-check${removed?' unchecked':''}"
                onclick="toggleProduct('${p.key}')"
                title="${removed ? l.restoreBtn : l.removeBtn}"
                aria-label="${removed ? l.restoreBtn : l.removeBtn}"
                aria-pressed="${removed?'false':'true'}">✓</button>
              <div class="prod-top">
                <div class="prod-name">${S.lang==='de'?p.de:p.en}</div>
                <div class="prod-price">${p.price}</div>
              </div>
              <span class="prio ${prioClass}">${prioText}</span>
              ${p.probe ? `<div style="margin-top:8px"><span class="prod-probe">🧪 ${p.probe}</span></div>` : ''}
              ${(S.lang==='de'?p.desc_de:p.desc_en) ? `<div class="prod-desc">${S.lang==='de'?p.desc_de:p.desc_en}</div>` : ''}
              ${p.params ? `<div class="prod-params">${p.params}</div>` : ''}
              <a class="prod-link" href="${SHOP}/products/${p.handle}" target="_blank" rel="noopener">${l.viewProduct}</a>
              &nbsp;·&nbsp;
              <a class="prod-link" href="${SHOP}/products/${p.handle}#musterbefund" target="_blank" rel="noopener">${l.viewSample}</a>
            </div>`;
        }).join('')}`;
    }).join('')}

    ${(() => {
      const effectiveSex = S.gender === 'other' ? S.bioSex : S.gender;
      if (!effectiveSex) return '';
      const hKey = effectiveSex === 'female' ? 'hormon_f' : 'hormon_m';
      const hp = (PRODUCTS[hKey] || [])[0];
      if (!hp) return '';
      const hName = S.lang === 'de' ? hp.de : hp.en;
      const hDesc = S.lang === 'de' ? hp.desc_de : hp.desc_en;
      const hormonBtnLabel = S.lang === 'de'
        ? (S.hormonOpt ? '✓ Zum Warenkorb hinzugefügt' : '+ Zum Warenkorb hinzufügen')
        : (S.hormonOpt ? '✓ Added to cart'            : '+ Add to cart');
      return `
        <div class="hormon-box${S.hormonOpt ? ' hormon-opted' : ''}">
          <div class="hormon-label">${l.sgHormonLabel}
            ${hp.comingSoon ? `<span class="soon-badge">${l.sgHormonSoon}</span>` : ''}
          </div>
          <div class="hormon-name">${hName}</div>
          ${hDesc ? `<div class="hormon-desc">${hDesc}</div>` : ''}
          <div class="hormon-params">${hp.params}</div>
          ${hp.comingSoon
            ? `<span class="btn-hormon btn-hormon-soon">${l.sgHormonSoon}</span>`
            : `<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-top:8px">
                 <a class="btn-hormon" href="${SHOP}/products/${hp.handle}" target="_blank" rel="noopener">${l.viewProduct}</a>
                 <button class="btn-hormon-opt${S.hormonOpt ? ' on' : ''}"
                   onclick="toggleHormon()" style="cursor:pointer">
                   ${hormonBtnLabel}
                 </button>
               </div>`}
        </div>`;
    })()}

    <div class="cart-cta">
      <div class="cart-cta-top">
        <span class="cart-cta-label">${l.cartLabel}</span>
        <span class="cart-count" id="cartCount2">${l.cartCount(totalSelected)}</span>
      </div>
      <button class="btn btn-p" onclick="orderAll()">${l.cartAllBtn}</button>
    </div>

    ${pkgHtml}

    <div class="nav" style="margin-top:10px">
      <button class="btn btn-ghost" onclick="back()">${l.back}</button>
      <button class="btn btn-p" style="background:var(--teal-hover)" onclick="next()">${l.continueBtn}</button>
    </div>

    <div class="coaching-box" style="margin-top:14px">
      <p>${l.rcoaching_q}</p>
      <button class="btn-outline" onclick="window.open('${COACHING_URL}','_blank')">${l.rcoaching_btn}</button>
    </div>

    <p class="res-legal">${l.legal}</p>`;
}

function rLead() {
  const l=t();
  return `<div class="tag">${l.s5tag}</div><h2>${l.s5h}</h2><p class="sub">${l.s5p}</p>
    <div class="field">
      <label for="fe">${l.s5email}</label>
      <input type="email" id="fe" value="${S.email}" placeholder="${l.s5emailPh}" oninput="S.email=this.value;updSubmit()" />
    </div>
    <div class="form-row">
      <div class="field">
        <label for="ff">${l.s5first}</label>
        <input type="text" id="ff" value="${S.first}" placeholder="${l.s5firstPh}" oninput="S.first=this.value;updSubmit()" />
      </div>
      <div class="field">
        <label for="fl">${l.s5last}</label>
        <input type="text" id="fl" value="${S.last}" placeholder="${l.s5lastPh}" oninput="S.last=this.value;updSubmit()" />
      </div>
    </div>
    <div class="field">
      <label for="fd">${l.s5dob}</label>
      <input type="date" id="fd" value="${S.dob}" max="${new Date().toISOString().split('T')[0]}" oninput="S.dob=this.value;updSubmit()" />
      <div class="field-note">${l.s5dobNote}</div>
    </div>
    <div class="field">
      <label for="fp">${l.s5phone}</label>
      <input type="tel" id="fp" value="${S.phone}" placeholder="${l.s5phonePh}" oninput="S.phone=this.value" />
    </div>
    <div class="check-row">
      <input type="checkbox" id="cc" ${S.consent?'checked':''} onchange="S.consent=this.checked;updSubmit()" />
      <label for="cc">${l.s5consent}</label>
    </div>
    <div class="check-row" style="margin-bottom:4px">
      <input type="checkbox" id="cer" ${S.emailResults?'checked':''} onchange="S.emailResults=this.checked" />
      <label for="cer">${l.s5emailResults}</label>
    </div>
    <div class="check-row" style="margin-bottom:4px">
      <input type="checkbox" id="ccb" ${S.callback?'checked':''} onchange="S.callback=this.checked" />
      <label for="ccb">${l.s5callback}</label>
    </div>
    <p class="field-note" style="margin-bottom:18px;font-style:italic">${l.s5privacy}</p>
    <div class="nav">
      <button class="btn btn-ghost" onclick="back()">${l.back}</button>
      <button class="btn btn-p" id="sb" onclick="submitLead()" ${!leadOk()?'disabled':''}>${l.submit}</button>
    </div>`;
}

function rConfirm() {
  const l=t();
  return `<div class="confirm-center">
    <div class="confirm-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="#2a9d8f" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline></svg>
    </div>
    <h2>${l.s6h}</h2>
    <p>${l.s6p.replace('\n\n','<br><br>')}</p>
    <button class="btn btn-p" style="margin-bottom:10px" onclick="orderAll()">${l.s6cart}</button>
    <button class="btn-outline" onclick="window.open('${SHOP}','_blank')">${l.s6shop}</button>
  </div>`;
}

/* ─── ACTIONS ────────────────────────────────────────────────────────── */
function toggleTopic(id,btn) {
  const i=S.topics.indexOf(id);
  if(i>-1){S.topics.splice(i,1);btn.classList.remove('on');}
  else{S.topics.push(id);btn.classList.add('on');}
  const nb=$('nb'); if(nb) nb.disabled=S.topics.length===0;
}

function toggleConc(tid,idx,btn) {
  if(!S.conc[tid]) S.conc[tid]=[];
  const a=S.conc[tid],i=a.indexOf(idx);
  if(i>-1){a.splice(i,1);btn.classList.remove('on');}
  else{a.push(idx);btn.classList.add('on');}
}

function setDepth(group,val,btn) {
  S[group]=val;
  btn.closest('.scale').querySelectorAll('.scale-btn').forEach(b=>b.classList.remove('on'));
  btn.classList.add('on');
  const nb=$('nb'); if(nb) nb.disabled=!depthReady();
}

function toggleProduct(key) {
  const card = $(`pc-${key}`);
  const btn  = card ? card.querySelector('.prod-check') : null;
  if (S.removed.has(key)) {
    // Wiederherstellen
    S.removed.delete(key);
    if (card) card.classList.remove('removed');
    if (btn)  { btn.classList.remove('unchecked'); btn.setAttribute('aria-pressed','true'); btn.title = t().removeBtn; }
  } else {
    // Entfernen
    S.removed.add(key);
    if (card) card.classList.add('removed');
    if (btn)  { btn.classList.add('unchecked'); btn.setAttribute('aria-pressed','false'); btn.title = t().restoreBtn; }
  }
  updateCartCount();
}

// Abwärtskompatibilität (falls noch irgendwo referenziert)
function removeProduct(key)  { if (!S.removed.has(key))  toggleProduct(key); }
function restoreProduct(key) { if (S.removed.has(key))   toggleProduct(key); }

function toggleHormon() {
  S.hormonOpt = !S.hormonOpt;
  // Hormonbox-Button + Zähler neu rendern (kein Full-Rerender nötig)
  const box = document.querySelector('.hormon-box');
  if (box) {
    box.classList.toggle('hormon-opted', S.hormonOpt);
    const btn = box.querySelector('.btn-hormon-opt');
    if (btn) {
      const l = t();
      btn.classList.toggle('on', S.hormonOpt);
      btn.textContent = S.lang === 'de'
        ? (S.hormonOpt ? '✓ Zum Warenkorb hinzugefügt' : '+ Zum Warenkorb hinzufügen')
        : (S.hormonOpt ? '✓ Added to cart'            : '+ Add to cart');
    }
  }
  updateCartCount();
}

function updateCartCount() {
  const n = selectedProducts().length + (S.hormonOpt ? 1 : 0);
  const l = t();
  [$('cartCount'), $('cartCount2')].forEach(el => { if(el) el.textContent = l.cartCount(n); });
}

function orderAll() {
  const sel     = selectedProducts();
  const withId  = sel.filter(p => p.variantId);
  const without = sel.filter(p => !p.variantId);

  // Hormonprodukt nur hinzufügen wenn User es explizit aktiviert hat
  if (S.hormonOpt) {
    const effectiveSex = S.gender === 'other' ? S.bioSex : S.gender;
    const hKey = effectiveSex === 'female' ? 'hormon_f' : effectiveSex === 'male' ? 'hormon_m' : null;
    if (hKey) {
      const hp = (PRODUCTS[hKey] || [])[0];
      if (hp && hp.variantId) withId.push(hp);
    }
  }

  if (withId.length) {
    // Shopify Cart-Permalink: navigiert direkt zum Warenkorb (kein Popup, kein async)
    const cartPath = withId.map(p => `${p.variantId}:1`).join(',');
    window.location.href = `/cart/${cartPath}`;
    return;
  }
  // Kein variantId gesetzt → Produktseite öffnen
  if (without.length) {
    window.location.href = `${SHOP}/products/${without[0].handle}`;
  }
}

function updSubmit() {
  const sb=$('sb'); if(sb) sb.disabled=!leadOk();
}

function buildPatientEmailHTML() {
  const l = t();
  const sel = selectedProducts();
  const date = new Date().toLocaleDateString('de-DE');
  const effectiveSexEmail = S.gender === 'other' ? S.bioSex : S.gender;
  const salutation = effectiveSexEmail === 'female' ? 'Liebe' : effectiveSexEmail === 'male' ? 'Lieber' : 'Hallo';

  const productRows = sel.map(p => {
    const name  = S.lang==='de' ? p.de : p.en;
    const desc  = S.lang==='de' ? (p.desc_de||'') : (p.desc_en||'');
    const link  = `${SHOP}/products/${p.handle}`;
    return `
      <tr>
        <td style="padding:14px 0;border-bottom:1px solid #e5e7eb;vertical-align:top">
          <div style="font-weight:700;font-size:15px;color:#111827;margin-bottom:4px">${name}</div>
          ${p.probe ? `<div style="font-size:12px;color:#6b7280;margin-bottom:4px">🧪 ${p.probe}</div>` : ''}
          ${desc    ? `<div style="font-size:13px;color:#374151;margin-bottom:6px">${desc}</div>` : ''}
          ${p.params? `<div style="font-size:11px;color:#9ca3af;margin-bottom:8px">${p.params}</div>` : ''}
          <div style="font-size:14px;font-weight:700;color:#2a9d8f;margin-bottom:8px">${p.price}</div>
          <a href="${link}" style="display:inline-block;background:#2a9d8f;color:#fff;padding:8px 16px;border-radius:7px;text-decoration:none;font-size:13px;font-weight:700">Jetzt bestellen →</a>
        </td>
      </tr>`;
  }).join('');

  return `<!DOCTYPE html><html lang="de"><head><meta charset="UTF-8"></head><body style="margin:0;padding:0;background:#f5f7f7;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif">
  <div style="max-width:600px;margin:40px auto;background:#fff;border-radius:12px;overflow:hidden;box-shadow:0 4px 28px rgba(0,0,0,0.07)">
    <div style="background:#2a9d8f;padding:28px 36px">
      <div style="color:#fff;font-size:20px;font-weight:700;letter-spacing:-.3px">ORY Analysis</div>
      <div style="color:rgba(255,255,255,.8);font-size:13px;margin-top:4px">Deine persönlichen Befragungsergebnisse</div>
    </div>
    <div style="padding:32px 36px">
      <p style="font-size:15px;color:#111827;margin:0 0 6px">${salutation} ${S.first},</p>
      <p style="font-size:14px;color:#6b7280;margin:0 0 28px;line-height:1.6">vielen Dank für deine Teilnahme am ORY Gesundheits-Quiz vom <strong>${date}</strong>. Basierend auf deinen Antworten haben wir folgende Analysen für dich zusammengestellt:</p>
      <table width="100%" cellpadding="0" cellspacing="0">${productRows}</table>
      <div style="margin-top:28px;padding:18px;background:#edf7f5;border-radius:10px;text-align:center">
        <p style="margin:0 0 12px;font-size:13px;color:#374151">Möchten Sie persönlich beraten werden?</p>
        <a href="${COACHING_URL}" style="display:inline-block;background:#2a9d8f;color:#fff;padding:10px 22px;border-radius:8px;text-decoration:none;font-size:13px;font-weight:700">Kostenlose Beratung buchen</a>
      </div>
      <p style="margin:24px 0 0;font-size:11px;color:#9ca3af;line-height:1.6;text-align:center">Diese Übersicht dient der allgemeinen Orientierung und stellt keine Diagnose dar.<br>ORY Berlin · <a href="${SHOP}" style="color:#2a9d8f">ory-berlin.de</a></p>
    </div>
  </div>
</body></html>`;
}

function submitLead() {
  if(!leadOk()) return;
  const sel  = selectedProducts();
  const prods = sel.map(p => S.lang==='de' ? p.de : p.en).join(', ');
  try {
    sessionStorage.setItem('ory_email',    S.email);
    sessionStorage.setItem('ory_name',     S.first+' '+S.last);
    sessionStorage.setItem('ory_dob',      S.dob);
    sessionStorage.setItem('ory_products', prods);
  } catch(e){}

  // ── E-Mail an ORY (intern) ──────────────────────────────────
  const phoneLine    = S.phone ? `Telefon: ${S.phone}\n` : '';
  const genderMap    = {female:'Frau', male:'Mann', other:'Divers', '':'–'};
  const bioSexNote   = S.gender === 'other' && S.bioSex ? ` (biologisch: ${S.bioSex === 'female' ? 'weiblich' : 'männlich'})` : '';
  const genderLine   = `Geschlecht: ${genderMap[S.gender]||'–'}${bioSexNote}\n`;
  const ageLabels    = {u25:'Unter 25', a2535:'25–35', a3645:'36–45', a4655:'46–55', a5665:'56–65', o65:'Über 65'};
  const ageLine      = `Altersgruppe: ${ageLabels[S.age]||'–'}\n`;
  const callbackLine = S.callback ? '→ Bitte zurückrufen (Expressberatung)\n' : '';
  const prodLines    = sel.map(p => `• ${S.lang==='de'?p.de:p.en} (${p.price}) → ${SHOP}/products/${p.handle}`).join('\n');
  const oryBody = `Neues Quiz-Ergebnis\n\nName: ${S.first} ${S.last}\nGeburtsdatum: ${S.dob}\nE-Mail: ${S.email}\n${phoneLine}${genderLine}${ageLine}\nEmpfohlene Produkte:\n${prodLines}\n\n${callbackLine}${S.emailResults?'→ Befragungsergebnisse an Patient gesendet.\n':''}`;
  const subject = encodeURIComponent(`ORY Quiz – ${S.first} ${S.last}`);
  window.open(`mailto:contact@ory-berlin.de?subject=${subject}&body=${encodeURIComponent(oryBody)}`, '_blank');

  // ── E-Mail an Patient (Befragungsergebnisse mit Bestelllinks) ─
  if (S.emailResults && S.email) {
    const patientBody = `Deine ORY Befragungsergebnisse\n\nHallo ${S.first},\n\nhierbei deine empfohlenen Analysen:\n\n${prodLines}\n\nFür eine persönliche Beratung: ${COACHING_URL}\n\nORY Berlin – ${SHOP}`;
    const patSubject  = encodeURIComponent(`Ihre ORY Befragungsergebnisse – ${new Date().toLocaleDateString('de-DE')}`);
    window.open(`mailto:${S.email}?subject=${patSubject}&body=${encodeURIComponent(patientBody)}`, '_blank');
  }

  // ── Zusammenfassung in neuem Tab öffnen ───────────────────────
  if (S.emailResults) {
    const html = buildPatientEmailHTML();
    const blob = new Blob([html], {type:'text/html'});
    const url  = URL.createObjectURL(blob);
    window.open(url, '_blank');
  }

  // Weiterleitung zur Shopify-Registrierungsseite
  setTimeout(function() {
    window.location.href = '/account/register';
  }, 800);
}

function next() {
  if(S.step===1&&S.gender==='other'&&!S.bioSex) return;  // divers: bioSex required
  if(S.step===2&&!S.age) return;                          // Altersgruppe erforderlich
  if(S.step===3&&S.topics.length===0) return;             // topics step now at 3
  if(S.step===6) { S.productList=[]; S.removed.clear(); S.hormonOpt=false; } // results step now at 6
  transition(()=>{ S.step++; render(); });
}

function back() {
  if(S.step===6){ S.productList=[]; S.removed.clear(); }
  transition(()=>{ S.step=Math.max(0,S.step-1); render(); });
}

function switchLang() {
  S.lang=S.lang==='de'?'en':'de';
  $('langBtn').textContent=S.lang==='de'?'EN':'DE';
  document.documentElement.lang=S.lang;
  if(S.step===6){ S.productList=[]; S.removed.clear(); }
  render();
}

function safeRender() {
  try {
    render();
  } catch(e) {
    const card = document.getElementById('card');
    if (card) card.innerHTML = '<div style="color:red;padding:20px;font-family:monospace">Quiz-Fehler: ' + e.message + '<br><pre>' + e.stack + '</pre></div>';
    console.error('Quiz render error:', e);
  }
}


// Globale Exposes fuer inline onclick/oninput-Handler und State-Objekt
window.S             = S;
window.next          = next;
window.back          = back;
window.render        = render;
window.orderAll      = orderAll;
window.setDepth      = setDepth;
window.submitLead    = submitLead;
window.toggleConc    = toggleConc;
window.toggleHormon  = toggleHormon;
window.toggleProduct = toggleProduct;
window.toggleTopic   = toggleTopic;
window.switchLang    = switchLang;
window.updSubmit     = updSubmit;
window.leadOk        = leadOk;
window.validEmail    = validEmail;
window.removeProduct = removeProduct;
window.restoreProduct= restoreProduct;
window.updateCartCount = updateCartCount;
window.scaleBars     = scaleBars;
window.scaleBtn      = scaleBtn;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', safeRender);
} else {
  safeRender();
}
/* cache-bust: 2026-05-12-v3 */
})();
